import React from 'react'

export const useOnStopTyping = (value, action, time) => {
  const [finalValue, setFinalValue] = React.useState(value)

  const isFirstRun = React.useRef(true)
  React.useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false
      return
    }

    const timeout = setTimeout(() => {
      setFinalValue(value)
      action && action(value)
    }, time || 650)
    return () => clearTimeout(timeout)
  }, [value, setFinalValue])

  return finalValue
}

export const useOnStopTypingState = (value, options = {}) => {
  const { action, time } = options
  const [localValue, setLocalValue] = React.useState(value)
  const finalValue = useOnStopTyping(localValue, null, time)
  return [localValue, finalValue, setLocalValue]
}
